import { createAction } from '@reduxjs/toolkit'
import { TStoreTemplate } from 'redux/config/root-types'
import { TTrailerTypeSubtype } from 'redux/modules/trailerTypeSubtype/TReducer'
import { ActionTypes_TrailerTypeSubtype } from 'redux/modules/trailerTypeSubtype/TActions'

const { StoreActions } = ActionTypes_TrailerTypeSubtype

export const Actions_TrailerTypeSubtype = {
  saga: {},

  store: {
    showLoader: createAction(StoreActions.IS_LOADER_SHOW),
    hideLoader: createAction(StoreActions.IS_LOADER_HIDE),
    saveTrailerTypeSubtype: createAction<TStoreTemplate<TTrailerTypeSubtype>>(StoreActions.SAVE_TRAILER_TYPE_SUBTYPE),
  },
}
